/**
 * vb-mundo.js
 * Controla la reproducción del video hero de la página de Mundo.
 *
 * Reglas:
 * - El video se reproduce automático en cualquier dispositivo (desktop y
 *   mobile por igual) — el video ya viene producido y ajustado por CSS al
 *   formato correspondiente (2:1 en desktop, 3:4 en mobile).
 * - Única excepción: si la persona tiene activada la preferencia de
 *   sistema "reducir movimiento" (accesibilidad), el video no se
 *   reproduce automáticamente y se queda en el primer frame (poster) —
 *   esto no modifica el archivo de video, solo evita el autoplay para
 *   ese grupo de usuarios.
 * - No se descarga el archivo de video hasta que se decide reproducirlo
 *   (preload="none" en el liquid), para no gastar datos innecesariamente.
 */
document.addEventListener('DOMContentLoaded', function () {
  var video = document.getElementById('vb-mundo-video');
  if (!video) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  video.muted = true;
  video.setAttribute('preload', 'auto');

  var playPromise = video.play();
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(function () {
      /* Autoplay bloqueado por el navegador: se queda en el poster, sin romper nada. */
    });
  }
});
